// eslint-disable-next-line import/prefer-default-export
export function requiresPrescription(regionProduct) {
  if (!regionProduct || !regionProduct.requires_prescription) {
    return false;
  }
  // Miyosmart is a bespoke glasses product with no supplier lens - it is edited
  // frame-only (frame/colour/shape/arms), like DresdenGo, so it never needs the
  // prescription, PD or lens steps.
  const name = (regionProduct.product && regionProduct.product.name) || '';
  return !name.toLowerCase().includes('miyosmart');
}
